import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Drawer } from 'antd';
import { H3_TITLE } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import DepartmentActions from '@Actions/departmentActions';
import TenantActions from '@Actions/tenantActions';
import H3Text from '@Uilib/h3Text';
import {
  EditOutlined,
} from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import DepartmentForm from '../DepartmentForm';
/**
 *
 */
class ListDepartment extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      departmentNameColumn: {
        title: 'DEPARTMENT',
        render: (text, record) => {
          const { isAdmin } = this.state;
          const { org, user } = this.props;
          const defaultAdminStoreId = org?.organisation?.[0]?.default_store_id;
          const defaultTenantStoreId = user?.tenant_info?.default_store_id;
          return (
            <div className="dept-name-wrapper">
              <H3Text text={(!isAdmin ? record?.alias_name : record?.department_name) || '-'} />
              {(isAdmin && (defaultAdminStoreId === record?.department_id)) && <H3Text text="Default" className="default-dept" />}
              {(!isAdmin && (defaultTenantStoreId === record?.tenant_department_id)) && <H3Text text="Default" className="default-dept" />}
            </div>
          );
        },
      },
      departmentUnitsColumn: {
        title: 'BUSINESS UNITS',
        render: (text, record) => (
          <div>
            {record?.tenant_departments?.filter((item) => item?.is_active)?.length || '0'}
          </div>
        ),
      },
      departmentActionsColumn: {
        title: '',
        render: (text, record) => {
          const { user } = this.props;
          return (
            <div className="list__actions">
              {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                Helpers.permissionTypes.UPDATE, user) && (
                  <div
                    className="roundIconButton"
                    onClick={() => {
                      this.setState({
                        showUpdateDepartmentDrawer: true,
                        selectedDepartment: record,
                      });
                    }}
                  >
                    <EditOutlined />
                  </div>
                )}
            </div>
          );
        },
      },
      showNewDepartmentDrawer: false,
      isAdmin: false,
      page: 1,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { user, getDepartments } = this.props;
    if (window.location.href.includes('/admin')) {
      getDepartments('', '', 1, 10, '', '', user?.tenant_info?.org_id, true);
      this.setState({ isAdmin: true });
    } else {
      getDepartments('', user?.tenant_info?.tenant_id);
      this.setState({ isAdmin: false });
    }
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && state.isAdmin && !state.isUserReady) {
      const { getTenants } = props;
      getTenants(1, '', true, props?.user?.tenant_info?.org_id, 100, () => { });
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   */
  getDepartmentColumns() {
    const {
      isAdmin, departmentNameColumn, departmentUnitsColumn, departmentActionsColumn,
    } = this.state;
    const columns = [departmentNameColumn];
    if (isAdmin) {
      columns.push(departmentUnitsColumn);
      columns.push(departmentActionsColumn);
    }
    return columns;
  }

  /**
   *
   * @return {*}
   */
  getDataSource() {
    const { isAdmin } = this.state;
    const { departments } = this.props;
    if (!isAdmin) {
      return departments?.data?.result?.departments;
    }
    return departments?.data?.departments;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      departments, getDepartmentsLoading, getDepartments, user, org,
    } = this.props;
    const {
      showUpdateDepartmentDrawer, selectedDepartment, showNewDepartmentDrawer, page, limit, isAdmin,
    } = this.state;
    const defaultAdminStoreId = org?.organisation?.[0]?.default_store_id;
    return (
      <Fragment>
        <Drawer
          placement="right"
          onClose={() => this.setState({ showUpdateDepartmentDrawer: false })}
          open={showUpdateDepartmentDrawer}
          width={isAdmin ? '720px' : '320px'}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header">
              <H3Text text="Update Department" className="custom-drawer__title" style={isAdmin ? {} : { width: '270px' }} />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showUpdateDepartmentDrawer: false })} />
            </div>
          </div>
          <DepartmentForm
            selectedDepartment={selectedDepartment}
            callback={() => {
              if (isAdmin) {
                getDepartments('', '', page, 10, '', '', user?.tenant_info?.org_id, true);
              } else {
                getDepartments('', user?.tenant_info?.tenant_id);
              }
              this.setState({ showUpdateDepartmentDrawer: false });
            }}
            disableTenantCheckboxes={defaultAdminStoreId === selectedDepartment?.department_id}
          />
        </Drawer>
        <Drawer
          placement="right"
          onClose={() => this.setState({ showNewDepartmentDrawer: false })}
          open={showNewDepartmentDrawer}
          width={isAdmin ? '620px' : '320px'}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={isAdmin ? { width: '570px' } : { width: '270px' }}>
              <H3Text text="Create New Department" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewDepartmentDrawer: false })} />
            </div>
          </div>
          <DepartmentForm
            callback={() => {
              if (isAdmin) {
                getDepartments('', '', page, 10, '', '', user?.tenant_info?.org_id, true);
              } else {
                getDepartments('', user?.tenant_info?.tenant_id);
              } this.setState({ showNewDepartmentDrawer: false });
            }}
            onClose={() => this.setState({ showNewDepartmentDrawer: false })}
          />
        </Drawer>
        <div className="doc-list__wrapper doc-list__tab-content">
          <div className="ant-row">
            <div className="ant-col-md-18 ant-col-xs-24">
              <div className={`doc-list__table-wrapper ${!isAdmin ? 'dept-table-container' : 'admin-dept-table-container'}`}>
                <Table
                  title={() => (
                    <div className="doc-list__table-header">
                      <div className="doc-list__table-header__left">
                        {`${departments?.data?.result?.departments?.length || '0'} Departments`}
                      </div>
                      <div className="doc-list__table-header__right">
                        <div className="doc-list__buttons-wrapper">
                          <H3Button
                            buttonType={defaultButtonTypes.BLUE_ROUNDED}
                            text="+ New Department"
                            onClick={() => this.setState({ showNewDepartmentDrawer: true })}
                            customClass="add-button"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  showHeader
                  loading={getDepartmentsLoading}
                  size="small"
                  columns={this.getDepartmentColumns()}
                  dataSource={this.getDataSource() || []}
                  currentPage
                  pagination={{
                    current: page,
                    pageSize: 10,
                    position: ['bottomRight'],
                    showSizeChanger: false,
                    total: departments?.data?.count,
                    onChange: (pg) => {
                      this.setState({ page: pg });
                      if (isAdmin) {
                        getDepartments('', '', pg, 10, '', '', user?.tenant_info?.org_id, true);
                      } else {
                        getDepartments('', user?.tenant_info?.tenant_id);
                      }
                    },
                  }}
                  bordered
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, DepartmentReducers,
}) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  departments: DepartmentReducers.departments,
  getDepartmentsLoading: DepartmentReducers.getDepartmentsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback, orgId, isAdmin) => dispatch(DepartmentActions.getDepartments(keyword, tenantId, page, limit, departmentId, callback, orgId, isAdmin)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback)),

});

ListDepartment.propTypes = {
  user: PropTypes.any,
  departments: PropTypes.any,
  getDepartmentsLoading: PropTypes.bool,
  getDepartments: PropTypes.func,
  getTenants: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListDepartment));
